import { Avatar, Box, Typography, IconButton, AppBar, useTheme, Popper, ClickAwayListener, Card, Divider, Tooltip, Button } from '@mui/material'
import { Link, useSearchParams, useNavigate, useLocation, Outlet } from 'react-router-dom'
import { useEffect, useState } from 'react'
import React from 'react'

import PlacementCycleContextProvider from '../../../contexts/placement-cycle.context'
import { Icons } from '../../../../shared/utils/icons'
import CustomTabs from '../../../../shared/components/common/CustomTabs'
import PageHeader from '../../../../shared/components/common/PageHeader'

const pageTabs = [
    { value: "students", icon: Icons.default.Group, label: "Students" },
    { value: "jobs", icon: Icons.default.Work, label: "Jobs" },
]

export default function PlacementTrackerHODandPrincipalAuditLayout () {

    const { palette, theme, layout } = useTheme()
    const navigate = useNavigate()
    const { pathname } = useLocation()

    const currentPage = pathname?.includes( "/students" ) ? "students" : pathname?.includes( "/jobs" ) ? "jobs" : 'students'

    return (
        <Box sx={{ height: "100%", display: "flex", flexGrow: 1, overflow: "auto" }}>
            {<PlacementCycleContextProvider>

                <Box
                    sx={{
                        height: "100%",
                        flexGrow: 1,
                        display: "flex",
                        flexDirection: "column",
                        minWidth: "0",
                        position: "relative",
                        overflow: "auto",
                    }}>
                    {<Box
                        id="page-content"
                        className={theme}
                        sx={{
                            bgcolor: palette.background.default,
                            width: "100%",
                            overflow: "auto",
                            flexGrow: 1,
                            display: "flex",
                            minWidth: "0",
                            position: "relative"
                        }}>

                        <Box sx={{ overflow: "auto", padding: layout.pagePadding, flexGrow: 1, display: "flex", flexDirection: "column", width: "100%", gap: 1, }} >
                            <PageHeader title="Placement Tracking" subtitle="Monitor your cohorts placement statuses." />
                            <CustomTabs value={currentPage} handleTabChange={( val ) => navigate( val )} tabs={pageTabs} styles={{ mb: 1 }} />
                            <Outlet />
                        </Box>

                    </Box>
                    }
                </Box>
            </PlacementCycleContextProvider>}

        </Box>
    )
}
